import { activeLocale, AppLocale } from 'lib/region'

export const tx = (locale: AppLocale, ar: string, en: string) => (locale === 'en' ? en : ar)

/** Current interface language. Call this while rendering so a language switch updates the text. */
export const t = (ar: string, en: string) => tx(activeLocale(), ar, en)
